export const DATA_APPS_ROOT_ID = "data-apps";
